import React, { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { showModal } from '../../../../actions/modal';
import { useDispatch } from 'react-redux';

const CatalogCard = (props) => {
  const {
    index,
    originalItem,
    moveCard,
    pushCard,
    handleCollapse,
    collapsedItems,
    befores,
    setBefores,
    handleDeleteCatalogItem,
    handleEditCatalogueTitle,
  } = props;

  const dispatch = useDispatch();

  const ref = useRef(null);
  const [{ isDragging, foo }, drag] = useDrag({
    item: { type: 'card', index, originalItem },
    collect: (monitor) => {
      return {
        foo: monitor.getClientOffset(),
        isDragging: monitor.isDragging(),
      };
    },
  });
  const [{ isHovered, isBefore }, drop] = useDrop({
    accept: 'card',
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      if (item.cardType === 'collection') {
        return;
      }
      if (item.originalItem.level !== originalItem.level) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      if (dragIndex === hoverIndex) {
        return;
      }
      const hoverBoundingRect = ref.current.getBoundingClientRect();
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;

      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }

      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      moveCard(item.originalItem, originalItem, dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
    drop: (item, monitor) => {
      const dragIndex = item.index;
      const hoverIndex = index;
      if (dragIndex === hoverIndex && originalItem.level === item.level) {
        return;
      }
      if (originalItem.level > item.originalItem.level) {
        return;
      }
      const hoverBoundingRect = ref.current.getBoundingClientRect();
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      if (clientOffset === null) {
        return;
      }
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      if (
        item.cardType === 'collection' ||
        item.originalItem.level !== originalItem.level ||
        (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) ||
        (dragIndex > hoverIndex && hoverClientY > hoverMiddleY)
      ) {
        if (originalItem.level < 4) {
          pushCard(item.originalItem, originalItem, item.cardType === 'collection');
          setBefores({});
        }
      }
    },
    collect: (monitor) => {
      let blabla = null;
      let blabla2 = monitor.getClientOffset();
      if (ref.current && monitor.getClientOffset()) {
        blabla = ref.current.getBoundingClientRect();
      }
      const isBefore =
        !monitor.isOver({ shallow: true }) && blabla && blabla2 && blabla.y > blabla2.y;
      const isHovered =
        monitor.isOver({ shallow: true }) &&
        monitor.getItem().originalItem.id !== originalItem.id &&
        originalItem.level < 4 &&
        originalItem.level <= monitor.getItem().originalItem.level;

      if (isBefore) {
        setBefores(originalItem);
      }

      if (isHovered) {
        setBefores({});
      }

      return {
        isHovered,
      };
    },
  });
  drag(drop(ref));

  const handleDelete = (originalItem) => {
    handleDeleteCatalogItem(originalItem);
  };

  const handleEditItem = (originalItem) => {
    dispatch(
      showModal('EditCatalogueTitle', {
        catalogueItem: originalItem,
        submitCallback: (newTitle) => {
          handleEditCatalogueTitle(originalItem, newTitle);
        },
      }),
    );
  };

  return (
    <li
      id={originalItem.id}
      ref={ref}
      className={`dd-item ${
        collapsedItems.find((ci) => ci.id === originalItem.id) &&
        !collapsedItems.find((ci) => ci.id === originalItem.id).status
          ? 'dd-collapsed'
          : ''
      }`}
    >
      {/* {originalItem.id !== 'main' && befores.id === originalItem.id ?
        <div className="put-before" />
      : null} */}
      <div className={`dd-handle ${isHovered ? 'is-hovered' : ''}`} style={{ display: 'flex' }}>
        {originalItem.children && originalItem.children.length ? (
          <div className="catalog-item-collapse">
            <i
              className={
                collapsedItems.find((ci) => ci.id === originalItem.id) &&
                !collapsedItems.find((ci) => ci.id === originalItem.id).status
                  ? 'fe-plus'
                  : 'fe-minus'
              }
              type="button"
              onClick={() => handleCollapse(originalItem)}
            />
          </div>
        ) : null}
        <div>{originalItem.title}</div>

        <div style={{ marginLeft: 'auto' }} onClick={() => handleEditItem(originalItem)}>
          <i className="fe-edit-2" />
        </div>

        {originalItem.id !== 'main' ? (
          <div style={{ marginLeft: '10px' }} onClick={() => handleDelete(originalItem)}>
            <i className="fe-trash-2" />
          </div>
        ) : null}
      </div>
      {originalItem.children && originalItem.children.length ? (
        <ol className="dd-list">
          {originalItem.children.map((collection, i) => (
            <CatalogCard
              key={collection.id}
              index={i}
              originalItem={collection}
              moveCard={moveCard}
              pushCard={pushCard}
              handleCollapse={handleCollapse}
              collapsedItems={collapsedItems}
              befores={befores}
              setBefores={setBefores}
              handleDeleteCatalogItem={handleDeleteCatalogItem}
              handleEditCatalogueTitle={handleEditCatalogueTitle}
            />
          ))}
        </ol>
      ) : null}
    </li>
  );
};
export default CatalogCard;
